/*
 * @Author: huangzeshen
 * @Date: 2024-03-28 14:02:19
 * @LastEditors: huangzeshen
 * @LastEditTime: 2024-04-03 10:24:20
 * @FilePath: /waton-mobile/src/i18n/locals/en-US/info.js
 * @Description: 
 */

export default {
  'info.market.header.title': 'Information',

  'info.market.name.1': 'US',
  'info.market.name.2': 'HK',
  'info.market.name.3': 'CN',

  'nav.news.detai.title': 'Detail',
  'asset.stock.purchare.detail.add.optional': 'Succeed',
  'asset.stock.purchare.detail.delete.optional': 'Removed',
  'news.days.ago': ' days ago',
  'news.hours.ago': ' hours ago',
  'news.minutes.ago': ' minutes ago',
  'news.seconds.ago': ' seconds ago',
}
